import React, { Component } from 'react';
import pure from 'recompose/pure';

/* Components */
import LazyImage from './../../_common/LazyImage/LazyImage';
/* Helpers*/
import { customPCPConfig } from '../../../../server/utils/customPCPConfig';
/* Styles */
import './singleImageBanner.scss';
/* Props */
interface ImpactTIATProps {
  handleRouteChange: () => void;
  containerWidth: number;
  backgroundColor?: string;
  category?: string;
  imgLink?: string;
  imgAlt?: string;
  linkCategory?: string;
  imgSrc: string;
  imgHeight?: number;
  imgWidth?: number;
  imgSrcTablet?: string;
  imgHeightTablet?: number;
  imgWidthTablet?: number;
  imgSrcMobile?: string;
  imgHeightMobile?: number;
  imgWidthMobile?: number;
  onPromotionClick?: () => void;
  promotionId?: string;
}

class SingleImageBanner extends Component<ImpactTIATProps, {}> {
  shouldComponentUpdate(nextProps: ImpactTIATProps) {
    return nextProps.containerWidth !== this.props.containerWidth;
  }

  getBottomBanner = () => {
    const { category } = this.props;
    if (!category) return undefined;
    const isCustomPage = customPCPConfig[category];
    return isCustomPage && isCustomPage.bottomBanner
      ? isCustomPage.bottomBanner
      : null;
  };

  render() {
    const {
      containerWidth,
      handleRouteChange,
      imgLink,
      imgAlt,
      linkCategory,
      backgroundColor,
      imgSrc,
      imgHeight,
      imgWidth,
      imgSrcTablet,
      imgHeightTablet,
      imgWidthTablet,
      imgSrcMobile,
      imgHeightMobile,
      imgWidthMobile,
    } = this.props;

    const bannerOneAlt = imgAlt;
    const isMobile = containerWidth < 640;
    const isTablet = containerWidth < 1024;
    const bannerOneImgSrc = isMobile
      ? imgSrcMobile
      : isTablet
      ? imgSrcTablet
      : imgSrc;
    const height = isMobile
      ? imgHeightMobile
      : isTablet
      ? imgHeightTablet
      : imgHeight;
    const width = isMobile
      ? imgWidthMobile
      : isTablet
      ? imgWidthTablet
      : imgWidth;
    return (
      <div className="singleImageBannerContainer">
        <LazyImage
          onPromotionClick={this.props.onPromotionClick}
          promotionId={this.props.promotionId}
          imgHeight={height}
          imgWidth={width}
          imgSrc={bannerOneImgSrc}
          imgLink={imgLink}
          linkCategory={linkCategory}
          imgAlt={bannerOneAlt}
          backgroundColor={backgroundColor}
          handleRouteChange={handleRouteChange}
        />
      </div>
    );
  }
}

export default pure(SingleImageBanner);
